import { html, SYSBaseElement, SYSTableDefIds } from "../../../../.."
import { T } from "../../../../../textapi"
import { SYSTableSettings_ColumnFilter } from "../columnfilter/tabledef"

import { GetRowDisplayValue, GetRowRawValue } from "../../../helpers"
import { _ColumnColumnFilter } from "../../../table"
import {
  SYSTableDef,
  TableColumnFilter,
  TableGet,
  _TableGetReturnType,
  TableOpenColumnFilter,
  TableRebuild,
} from "../../../tableapi"
import { FormGet } from "../../../../forms/formapi"
import { HeaderMenuFilterFieldsSetState } from "../hookactions"

export class SYSHeaderMenuColumnFilter extends SYSBaseElement {
  defId: SYSTableDefIds
  columnKey: string
  tableDef: _TableGetReturnType<SYSTableSettings_ColumnFilter>
  filter: _ColumnColumnFilter
  baseRows: {}
  baseDef: SYSTableDef

  getDisplayValue() {
    if (this.filter.type === "none") {
      return T("SYSFilterAll")
    }
    let list = []
    let nullHandling = this.baseDef.columns[this.columnKey].nullHandling.enabled
    // let isCalculated =
    //   this.baseDef.columns[this.columnKey].schema?.isCalculatedColumn
    if (this.filter.list) {
      this.filter.list.slice(0, 100).forEach((k) => {
        let foundRowKey = undefined
        Object.keys(this.baseRows).some((s) => {
          let val
          // if (isCalculated) {
          val = GetRowRawValue(
            this.baseDef,
            this.columnKey,
            this.baseRows[s],
            s,
            "ColumnFilter"
          )
          // } else {
          //   val = this.baseRows[s][this.columnKey]
          // }

          if (val === k || (!nullHandling && k === "" && val === null)) {
            foundRowKey = s
            return true
          }
        })
        if (foundRowKey !== undefined) {
          let val = GetRowDisplayValue(
            this.baseDef,
            this.columnKey,
            this.baseRows[foundRowKey],
            foundRowKey,
            "ColumnFilter"
          )

          if (val === null) {
            list.push(T("SYSFilterNull"))
            return
          }
          if (val === "") {
            list.push(T("SYSFilterEmpty"))
            return
          }

          list.push(val)
        }
      })
    }

    return html`${this.filter.exclusive
      ? T("SYSFilterExclusive") + ": "
      : ""}${list.map((m, i) => html`${m}${i < list.length - 1 ? ", " : ""}`)}`
  }

  async openAdvancedColumnFilter() {
    await TableOpenColumnFilter(this.defId, this.columnKey, {
      allowExclusive: true,
    })
  }
  async init() {
    this.tableDef = TableGet<SYSTableSettings_ColumnFilter>(this.defId)
    let baseTable = TableGet(this.defId)
    this.baseDef = baseTable.def
    this.baseRows = baseTable.rows
    await super.init()
  }
  async getUI() {
    this.filter =
      this.tableDef.def.uiState.filter.columns[this.columnKey].columnFilter

    let clearFilterButton = html`<button
      @click=${async (e) => {
        if (
          await TableColumnFilter(this.tableDef.def.id, this.columnKey, [], {
            exclusive: false,
            _innerEvent: true,
          })
        ) {
          await TableRebuild(this.tableDef.def.id, { showProcess: true })
          HeaderMenuFilterFieldsSetState(
            FormGet("SYSHeaderMenuFilter", { instance: "1" }).formState
          )
        }
      }}
      class="fd-button"
      ?disabled=${this.filter.type === "none"}
    >
      <i class="sap-icon--clear-filter"></i>
    </button>`

    this.filter =
      this.tableDef.def.uiState.filter.columns[this.columnKey].columnFilter

    return html`<div class="ovl-cols3-big1">
      <div class="fd-segmented-button" role="group" aria-label="Tablefilter">
        <div
          class="fd-input __columnFilterList"
          type="text"
          @click=${async () => {
            await this.openAdvancedColumnFilter()
          }}
          readonly
        >
          ${this.getDisplayValue()}
        </div>

        ${clearFilterButton}
        <button
          class="fd-button"
          @click=${async () => {
            await this.openAdvancedColumnFilter()
          }}
        >
          <i class="sap-icon--overflow"></i>
        </button>
      </div>
    </div> `
  }
}
